export function hasZeroZValues(geojson) {
    if (geojson.type == "FeatureCollection") {
        if (geojson.features.length > 0) {
            const sample_feature = geojson.features[0];
            let sample_coords = null;
            switch (sample_feature.geometry.type) {
                case "Point":
                    sample_coords = sample_feature.geometry.coordinates;
                    break;
                case "LineString":
                case "MultiPoint":
                    sample_coords = sample_feature.geometry.coordinates[0];
                    break;
                case "Polygon":
                case "MultiLineString":
                    sample_coords = sample_feature.geometry.coordinates[0][0];
                    break;
                case "MultiPolygon":
                    sample_coords = sample_feature.geometry.coordinates[0][0][0];
                    break;
            }
            if (sample_coords) {
                if (sample_coords.length == 3)
                    if (sample_coords[2] == 0)
                        return true;
            }
        }
    }
    return false;
}
export function hasUniqueGeometryType(geojson) {
    if (geojson.type == "FeatureCollection") {
        if (geojson.features.length > 0) {
            const feature_types = geojson.features.map((feature) => feature.geometry.type);
            return feature_types.every((mytype) => mytype == feature_types[0]);
        }
    }
    return false;
}
export function hasSupportedGeometryType(geojson) {
    if (geojson.type == "FeatureCollection") {
        if (geojson.features.length > 0) {
            const feature_types = geojson.features.map((feature) => feature.geometry.type);
            return feature_types.every((mytype) => ["Point", "MultiPoint", "LineString", "Polygon", "MultiLineString", "MultiPolygon"].indexOf(mytype) > -1);
        }
    }
    return false;
}
export function isValidGeoJSON(json) {
    if (json.type !== undefined) {
        if (json.type == "FeatureCollection")
            return true;
    }
    return false;
}
export function removeUnsupportedGeometries(geojson) {
    if (geojson.type == "FeatureCollection") {
        const parsed_feature_array = [];
        for (const feature of geojson.features) {
            if (feature.geometry.type != "GeometryCollection") {
                parsed_feature_array.push(feature);
            }
        }
        geojson.features = parsed_feature_array;
    }
    return geojson;
}
export function hasWGSCoords(geojson) {
    if (geojson.type == "FeatureCollection") {
        if (geojson.features.length > 0) {
            const first_feature = geojson.features[0];
            let coords = [0, 0];
            switch (first_feature.geometry.type) {
                case "Point":
                    coords = first_feature.geometry.coordinates;
                    break;
                case "LineString":
                case "MultiPoint":
                    coords = first_feature.geometry.coordinates[0];
                    break;
                case "Polygon":
                case "MultiLineString":
                    coords = first_feature.geometry.coordinates[0][0];
                    break;
                case "MultiPolygon":
                    coords = first_feature.geometry.coordinates[0][0][0];
                    break;
            }
            if (coords[0] >= -180 && coords[0] <= 180 && coords[1] >= -90 && coords[1] <= 90) {
                return true;
            }
        }
    }
    return false;
}
export function parseGeoJSON(geojson, checkwgscoords = true, checkuniquegeometrytype = false, checkvalidgeojson = true) {
    if (checkvalidgeojson)
        if (!isValidGeoJSON(geojson))
            return { data: null, valid: false, message: "notvalidgeojson" };
    if (geojson.features.length == 0) {
        return { data: geojson, valid: true, message: "ok" };
    }
    if (!hasSupportedGeometryType(geojson))
        geojson = removeUnsupportedGeometries(geojson);
    if (checkuniquegeometrytype)
        if (!hasUniqueGeometryType(geojson))
            return { data: null, valid: false, message: "nouniqegeometrytype" };
    if (checkwgscoords)
        if (!hasWGSCoords(geojson))
            return { data: null, valid: false, message: "wrongcrs" };
    return { data: geojson, valid: true, message: "ok" };
}
export function splitGeoJSON(geojson, get_layer_fnc) {
    const groupped_data = geojson.features.reduce(function (r, a) {
        const layer = get_layer_fnc(a);
        const layer_array = r[layer] || [];
        layer_array.push(a);
        r[layer] = layer_array;
        return r;
    }, {});
    Object.keys(groupped_data).forEach(function (key) {
        const group = groupped_data[key];
        const geometrytype_grouped = group.reduce(function (r, a) {
            const geometrytype = a.geometry.type;
            const geomtype_array = r[geometrytype] || [];
            geomtype_array.push(a);
            r[geometrytype] = geomtype_array;
            return r;
        }, {});
        groupped_data[key] = geometrytype_grouped;
    });
    const layerconfigs = [];
    for (const layer in groupped_data) {
        for (const geometrytype in groupped_data[layer]) {
            layerconfigs.push({
                data: {
                    type: "FeatureCollection",
                    features: groupped_data[layer][geometrytype],
                },
                title: layer,
            });
        }
    }
    return layerconfigs;
}
//# sourceMappingURL=utils.js.map